import { combineReducers } from 'redux';

import token from './tokenReducer'
import error from './errorReducer'

export default combineReducers({ token, error });
